import { useTheme } from '@mui/material';

interface OrdersIllustrationProps {
  width?: number | string;
  height?: number | string;
}

const OrdersIllustration = ({ width = 130, height = 120 }: OrdersIllustrationProps) => {
  const { palette } = useTheme();

  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 130 120"
      fill="none"
      style={{ display: 'block' }}
    >
      <path
        d="M65 108.273C97.5848 108.273 124 103.897 124 98.4996C124 93.1021 97.5848 88.7266 65 88.7266C32.4152 88.7266 6 93.1021 6 98.4996C6 103.897 32.4152 108.273 65 108.273Z"
        stroke={palette.text.disabled}
        strokeWidth="1.57939"
        strokeLinecap="round"
        strokeDasharray="0.36 5.79"
      />
      <path
        d="M94.6453 16.0234H39.8871C36.6541 16.0234 34.0332 18.5445 34.0332 21.6543V93.475C34.0332 96.5849 36.6541 99.1059 39.8871 99.1059H94.6453C97.8783 99.1059 100.499 96.5849 100.499 93.475V21.6543C100.499 18.5445 97.8783 16.0234 94.6453 16.0234Z"
        fill={palette.divider}
        stroke={palette.divider}
        strokeWidth="0.474757"
      />
      <path
        d="M91.8953 11H34.3078C31.1002 11 28.5 13.5898 28.5 16.7844V90.7906C28.5 93.9853 31.1002 96.575 34.3078 96.575H91.8953C95.1028 96.575 97.703 93.9853 97.703 90.7906V16.7844C97.703 13.5898 95.1028 11 91.8953 11Z"
        fill={palette.background.paper}
        stroke={palette.text.primary}
        strokeMiterlimit="10"
      />
      <path
        d="M49.6697 22.4463H40.4842C39.2395 22.4463 38.2305 23.4512 38.2305 24.6909C38.2305 25.9306 39.2395 26.9355 40.4842 26.9355H49.6697C50.9144 26.9355 51.9234 25.9306 51.9234 24.6909C51.9234 23.4512 50.9144 22.4463 49.6697 22.4463Z"
        fill={palette.text.disabled}
      />
      <path
        d="M85.6994 35.6094H39.5937C38.8408 35.6094 38.2305 36.824 38.2305 38.3223C38.2305 39.8206 38.8408 41.0352 39.5937 41.0352H85.6994C86.4523 41.0352 87.0626 39.8206 87.0626 38.3223C87.0626 36.824 86.4523 35.6094 85.6994 35.6094Z"
        fill={palette.action.hover}
      />
      <path
        d="M85.6994 49.6201H39.5937C38.8408 49.6201 38.2305 50.8347 38.2305 52.333C38.2305 53.8313 38.8408 55.0459 39.5937 55.0459H85.6994C86.4523 55.0459 87.0626 53.8313 87.0626 52.333C87.0626 50.8347 86.4523 49.6201 85.6994 49.6201Z"
        fill={palette.action.hover}
      />
      <path
        d="M85.6994 63.6309H39.5937C38.8408 63.6309 38.2305 64.8455 38.2305 66.3438C38.2305 67.8421 38.8408 69.0567 39.5937 69.0567H85.6994C86.4523 69.0567 87.0626 67.8421 87.0626 66.3438C87.0626 64.8455 86.4523 63.6309 85.6994 63.6309Z"
        fill={palette.action.hover}
      />
      <path
        d="M85.6994 77.6416H39.5937C38.8408 77.6416 38.2305 78.8562 38.2305 80.3545C38.2305 81.8528 38.8408 83.0674 39.5937 83.0674H85.6994C86.4523 83.0674 87.0626 81.8528 87.0626 80.3545C87.0626 78.8562 86.4523 77.6416 85.6994 77.6416Z"
        fill={palette.action.hover}
      />
    </svg>
  );
};

export default OrdersIllustration;
